























import { MaterialTypeServiceProxy, MaterialServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
import { Modal } from 'ant-design-vue'
import Vue from 'vue'
const materialTypeServiceProxy = new MaterialTypeServiceProxy()
const materialServiceProxy = new MaterialServiceProxy()
export default Vue.extend({
  name: 'SelectMaterial',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectProducts: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      materialTypeId: '',
      materialTypeList: []
    }
  },
  created() {
    materialTypeServiceProxy.getMaterialTypeList().then(res => {
      this.materialTypeList = res
      console.log('221', res)
    })
  },
  methods: {
    close() {
      this.$emit('closeSelectMaterial')
    },
    handleSubmit() {
      console.log('selectProducts', this.selectProducts)
      if (!this.materialTypeId) {
        this.$message.error('请先选择物料类型，再进行同步！')
        return
      }
      const param = {
        typeId: this.materialTypeId,
        productList: this.selectProducts,
        isDetele: 0
      } as any
      materialServiceProxy.synchronousProductMaterial(param).then(res => {
        if (res === 0) {
          Modal.confirm({
            title: this.$t('page_sync_infomation'),
            content: this.$t('page_material_sync_msg'),
            onOk: async () => {
              param.isDetele = 2
              materialServiceProxy.synchronousProductMaterial(param).then(res => {
                this.success()
              })
            },
          })
        } else {
          this.success()
        }
      })
    },
    success() {
      this.$message.success(this.$t('sync_success'));
      this.$emit('closeSelectMaterial')
    }
  }
})
